import { type UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query';
import { BffQueryKey } from '../model/BffQueryKey';
import { getPaymentsByMethodId } from '../utils/payment-utils';
import { useBasket } from './useBasket';
import { useDeletePayment } from './useDeletePayment';
import type { PaymentMethodId } from './model';

export const useDeletePaymentByMethodId = (): UseMutationResult<
    unknown,
    unknown,
    PaymentMethodId
> => {
    const queryClient = useQueryClient();

    const { data } = useBasket();
    const deletePayment = useDeletePayment({ skipInvalidateQueries: true });

    return useMutation<unknown, unknown, PaymentMethodId>({
        mutationFn: async (paymentMethodId: PaymentMethodId) => {
            const payments = getPaymentsByMethodId(data, paymentMethodId);
            await Promise.all(
                payments.map((payment) => deletePayment.mutateAsync(payment.paymentInstrumentId!)),
            );
        },
        onSuccess: async (): Promise<void> => {
            await Promise.all([
                queryClient.invalidateQueries([BffQueryKey.PAYMENT_METHODS], {
                    exact: false,
                }),
            ]);
        },
    });
};
